<template>
  <v-container class="fill-height align-content-start py-0" fluid>
    <p-header 
      :configurations="this.configurations"
    />
    
    <v-row align="center" justify="center">
      <v-col class="px-md-5 px-lg-10 px-xl-10 px-xs-1 px-sm-1">
        <v-stepper v-model="stepper" class="fluid" vertical>
          <v-stepper-step :complete="stepper > 1" step="1">
            Datos del pago 
            <!-- <small>Summarize if needed</small> -->
          </v-stepper-step>

          <v-stepper-content step="1">
            <validation-observer ref="issuerReceiver">
              <v-row justify="center">
                <receiver
                  ref="receiver"
                  class="mx-6 my-2 pb-2"
                  v-model="commerce"
                  :readonly="!enabledReceiver"
                  :visible="visible_params"
                  :webcheckout="webcheckout"
                  :configurations="this.configurations"
                >
                  <template v-if="!hasParams" slot="footer">
                    <v-btn
                      v-if="enabledReceiver == false"
                      class="align-self-center"
                      color="primary"
                      @click.prevent="editReceiver"
                      rounded
                      text
                    >
                      Editar
                    </v-btn>
                    
                    <v-btn
                      class="align-self-center"
                      color="primary"
                      @click.prevent="
                        () => doReceiverValidation(commerce.phone,commerce.amount)
                      "
                    >
                      Validar
                    </v-btn>
                  </template>
                </receiver>
                <issuer 
                v-if="validReceiver" 
                v-model="user" 
                class="mx-5 my-2"
                @groupChange="groupChange"
                :web_checkout="web_checkout"
                :sublink="this.configurations.data.checkbox"
                :sublink_options="this.configurations.data.detail_checkbox"
                :reference="this.configurations.data.reference"
                :configurations="this.configurations" />
              </v-row>

              <v-btn
                v-if="validReceiver"
                :color="this.configurations.data.header_color"
                @click="validateUserInformation"
                class="ml-3 mt-2"
              >
                <span style="color: white">Continuar</span>
              </v-btn>
            </validation-observer>
          </v-stepper-content>

          <v-stepper-step :color="this.configurations.data.header_color" :complete="stepper > 2" step="2"
            >Método de pago</v-stepper-step
          >

          <!-- <v-row class="ma-5" align="center" justify="center">
            <logo v-if="false" class="mx-5" type="mastercard" />
            <logo v-if="mode === 'puntopay'" class="mx-5" type="davivienda" />
            <logo class="mx-5" type="visa" />
            <logo
              class="mx-5"
              type="pse"
              height="100px"
              squared
            />
          </v-row> -->

          <v-stepper-content
            step="2"
            class="align-content-center justify-center"
          >
            <v-row class="justify-center align-center">
              <!-- <v-btn class="mr-3" color="primary" @click="processPayment"
                >Pagar</v-btn
              > -->
              <iframe v-if="iframe" name="nameFrame" src="payment_form.php" width="100%" class="iframe" frameBorder="0" scrolling="auto" />
              <form
                method="POST"
                action="https://secure.payzen.lat/vads-payment/"
                target="nameFrame"
                v-show="!iframe"
              >
                <input
                  type="hidden"
                  name="vads_action_mode"
                  value="IFRAME"
                />
                <input type="hidden" name="vads_amount" :value="this.commerce.amount * 100" />
                <input type="hidden" name="vads_ctx_mode" :value="ctx_mode" />
                <input type="hidden" name="vads_currency" value="170" />
                <input
                  type="hidden"
                  name="vads_cust_cell_phone"
                  :value="this.user.finalphone"
                />
                <input
                  type="hidden"
                  name="vads_language"
                  value="es"
                />
                <input
                  type="hidden"
                  name="vads_payment_cards"
                  value="VISA;MASTERCARD"
                />
                <input
                  type="hidden"
                  name="vads_cust_email"
                  :value="this.user.email"
                />
                <input
                  type="hidden"
                  name="vads_cust_first_name"
                  :value="this.user.name"
                />
                <input
                  type="hidden"
                  name="vads_cust_last_name"
                  :value="this.user.lastname"
                />
                <input
                  type="hidden"
                  name="vads_cust_phone"
                  value=""
                />
                <input type="hidden" name="vads_page_action" value="PAYMENT" />
                <input
                  type="hidden"
                  name="vads_payment_config"
                  value="SINGLE"
                />
                <input type="hidden" name="vads_site_id" :value="site_id" />
                <input
                  type="hidden"
                  name="vads_trans_date"
                  :value="trans_date"
                />
                <input type="hidden" name="vads_trans_id" :value="trans_id" />
                <input type="hidden" name="vads_version" value="V2" />
                <input
                  type="hidden"
                  name="signature"
                  :value="trans_signature"
                />

                <v-btn :color="this.configurations.data.header_color" style="background-color:white;color:black" v-on:click="iframe=true" name="pagar" type="submit">
                  <img src="../assets/all-min.png" class="mx-3 my-2" /><span
                      >Tarjeta crédito</span
                    >  
                </v-btn>
              </form>

              <form
                method="POST"
                action="https://secure.payzen.lat/vads-payment/"
                target="nameFrame"
                v-show="!iframe"
                style="margin: 10px 10px"
              >
                <input
                  type="hidden"
                  name="vads_action_mode"
                  value="INTERACTIVE"
                />
                <input type="hidden" name="vads_amount" :value="this.commerce.amount * 100" />
                <input type="hidden" name="vads_ctx_mode" :value="ctx_mode" />
                <input type="hidden" name="vads_currency" value="170" />
                <input
                  type="hidden"
                  name="vads_cust_cell_phone"
                  :value="this.user.finalphone"
                />
                <input
                  type="hidden"
                  name="vads_payment_cards"
                  value="PSE"
                />
                <input
                  type="hidden"
                  name="vads_cust_email"
                  :value="this.user.email"
                />
                <input
                  type="hidden"
                  name="vads_cust_first_name"
                  :value="this.user.name"
                />
                <input
                  type="hidden"
                  name="vads_cust_last_name"
                  :value="this.user.lastname"
                />
                <input
                  type="hidden"
                  name="vads_language"
                  value="es"
                />
                <input
                  type="hidden"
                  name="vads_cust_phone"
                  value=""
                />
                <input type="hidden" name="vads_page_action" value="PAYMENT" />
                <input
                  type="hidden"
                  name="vads_payment_config"
                  value="SINGLE"
                />
                <input type="hidden" name="vads_site_id" :value="site_id" />
                <input
                  type="hidden"
                  name="vads_trans_date"
                  :value="trans_date"
                />
                <input type="hidden" name="vads_trans_id" :value="trans_id" />
                <input type="hidden" name="vads_version" value="V2" />
                <input
                  type="hidden"
                  name="signature"
                  :value="trans_signature_pse"
                />
                <v-btn :color="this.configurations.data.header_color" style="background-color:white;color:black; border-top-right-radius: 0px;border-bottom-right-radius: 0px;" name="pagar" type="submit">
                  <img src="../assets/pse.png" class="mx-3 my-2" /><span
                    >Débito bancario PSE</span
                  >
                  </v-btn>
              </form>

            </v-row>


            <!-- <v-row class="justify-center">
              <v-btn-toggle
                v-model="tab"
                color="primary"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 0px;"
              >
                <template v-slot:default>
                  <v-row class="text-center justify-center">
                    <v-col cols="12" sm="auto" md="auto" class="ma-0 pa-0">
                      <v-btn block>
                        <template v-slot:default>
                          <div class="d-flex align-center">
                            <logo
                              class="mr-2 ml-1"
                              type="credit-card"
                              height="40px"
                              squared
                            />
                            Tarjeta de crédito
                          </div>
                        </template>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="auto" md="auto" class="ma-0 pa-0">
                      <v-btn
                        color="primary"
                        class="white--text"
                        block
                        style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
                      >
                        <template v-slot:default>
                          <div class="d-flex align-center">
                            <logo
                              type="pse"
                              class="mr-2 ml-1"
                              squared
                              height="40px"
                            />
                            PSE
                          </div>
                        </template>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-btn-toggle>
            </v-row> -->

            <!-- <v-tabs-items v-model="tab" class="px-5">
              <validation-observer ref="payment">
                <v-tab-item key="cc">
                  <v-card class="mt-7" flat>
                    <credit-card
                      v-if="tab === 0"
                      ref="creditCard"
                      v-model="paymentData"
                      @on-confirm="openConfirm"
                      :error="errorCC"
                    />
                  </v-card>
                </v-tab-item>

                <v-tab-item key="pse">
                  <v-card flat>
                    <PSE
                      v-if="tab === 1"
                      v-model="paymentData"
                      :bank-list="bankList"
                      @on-confirm="openConfirm"
                      :error="errorPSE"
                    />
                  </v-card>
                </v-tab-item>
              </validation-observer>
            </v-tabs-items> -->

            <div
              v-if="tab !== null && tab !== undefined"
              class="d-flex flex-column align-center align-content-center"
            >
              <h4>
                Para información adicional, puedes escribirnos a
                <a @click.stop="" href="mailto:sac@soyveci.com"
                  >servicio al cliente</a
                >
              </h4>

              <!-- <v-row>
                <v-btn
                  color="primary"
                  class="mt-5 mx-3"
                  @click="openConfirm" 
                  style="width: 90%;"
                >
                  <span style="white-space: normal; font-size: 0.8rem;">
                    {{
                      tab == 0
                        ? "Pagar con tarjeta de crédito"
                        : "Pagar con PSE"
                    }}
                  </span>
                </v-btn>
              </v-row> -->
            </div>

            <v-row class="justify-center">
              <v-btn
                color="primary"
                class="mt-2 align-self-center"
                @click="returnShop"
                small
                text
                >Volver a la tienda</v-btn
              >
            </v-row>

            <v-row class="justify-center">
              <v-btn
                color="primary"
                class="mt-2 align-self-center"
                @click="backStepper"
                small
                text
                >Cancelar</v-btn
              >
            </v-row>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>

    <p-footer 
      :color="this.configurations.data.footer_color"
    />

    <v-dialog v-model="dialog.confirmPayment" max-width="410">
      <v-card>
        <v-card-title class="headline accent">
          <span style="color: white; word-break: normal;"
            >¿Está seguro de realizar el pago?</span
          >
        </v-card-title>

        <v-card-text class="pt-4">
          <span style="word-break: normal;">
            Usted, <strong>{{ user.name }} {{ user.lastname }}</strong> con
            <strong>{{ user.documentType }} {{ user.document }}</strong> le
            realizará un pago de $<strong>{{ commerce.amount }}</strong> COP al
            vendedor con número de celular:
            <h2 style="text-align: center">
              <strong>{{ commerce.phone }}</strong>
            </h2>
          </span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="accent darken-1"
            text
            @click="dialog.confirmPayment = false"
          >
            Cancelar
          </v-btn>

          <v-btn color="primary darken-1" text @click="onConfirm">
            Confirmar pago
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.invalidNumber.state"
      :persistent="dialog.invalidNumber.persistent"
      width="500"
    >
      <v-card>
        <v-card-title class="headline accent">
          <span style="color:white; word-break: normal;">
            ¡Este número no está autorizado para recibir pagos!</span
          ></v-card-title
        >

        <v-card-text class="pb-0">
          <v-row>
            <v-col class="align-self-center">
              Verifica que el número que ingresaste está correcto, o contáctate
              con el vendedor.
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="!dialog.invalidNumber.persistent"
            color="primary darken-1"
            text
            @click="dialog.invalidNumber.state = false"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog
      v-model="dialog.invalidAmount.state"
      :persistent="dialog.invalidAmount.persistent"
      width="500"
    >
      <v-card>
        <v-card-title class="headline accent">
          <span style="color:white; word-break: normal;">
            ¡El monto ingresado no es permitido!</span
          ></v-card-title
        >

        <v-card-text class="pb-0">
          <v-row>
            <v-col class="align-self-center">
              Verifica que el valor que ingresaste, está en los montos permitidos.
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="!dialog.invalidAmount.persistent"
            color="primary darken-1"
            text
            @click="dialog.invalidAmount.state = false"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <offline @detected-condition="handleConnectivityChange" />

    <!-- <v-dialog v-model="dialog.checkInternetConnection" width="500">
      <v-card class="primary" dark>
        <v-card-title class="headline">
          <span style="color:white; word-break: normal;">
            Parece que no tienes conexión a internet
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col class="align-self-center">
              Revisa tu conexión a internet e intenta ingresar nuevamente. Si
              continúas presentando problemas, comunícate con nosotros.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="dialog.invalidSignature" persistent width="400">
      <v-card color="primary" class="pa-3 pt-4" dark>
        <v-card-title class="headline">
          <strong>¡Link de pago inválido!</strong></v-card-title
        >
        <v-card-text>
          Asegúrate que el enlace al que estás intentando acceder esté correcto.
          <br />
          Si sigues teniendo problemas, comunícate con el vendedor.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.successfulPayment" width="500">
      <v-card>
        <v-card-title class="headline accent">
          <span style="color:white; word-break: normal;">
            ¡Pago realizado exitosamente!</span
          ></v-card-title
        >

        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="auto" class="align-self-center">
              <v-img
                alt="Puntored logo"
                :src="iconUrl"
                style="height: 80px; width: 80px;"
              />
            </v-col>
            <v-col class="align-self-center">
              Trabajamos constantemente para ofrecerte los mejores servicios.
              Gracias por preferirnos.
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary darken-1" text @click="onAccept">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.invalidData" width="500">
      <v-card>
        <v-card-title class="headline accent">
          <span style="color:white; word-break: normal;">
            ¡Tus datos son incorrectos, por favor verifica e inténtalo nuevamente!</span
          ></v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary darken-1" text @click="onAcceptData">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.waitingPayment" persistent width="400">
      <v-card color="primary" class="pa-3 pt-4" dark>
        <v-card-text>
          Autorizando pago
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//import { Kushki } from "@kushki/js";
import Issuer from "./Issuer.vue";
import Receiver from "./Receiver.vue";
// import CreditCard from "./CreditCard.vue";
import Header from "./Header.vue";
// import PSE from "./PSE.vue";
import offline from "v-offline";
import Footer from "./Footer";

const CALLBACK_URL = process.env.VUE_APP_CALLBACK_URL;

export default {
  name: "Main",
  components: {
    Issuer,
    Receiver,
    // CreditCard,
    // PSE,
    offline,
    "p-header": Header,
    "p-footer": Footer
  },
  data() {
    return {
      tab: null,
      stepper: 1,
      paymentMethod: undefined,
      //bankList: undefined,
      enabledReceiver: true,
      mode: process.env.VUE_APP_MODE,
      visible_params: true,
      web_checkout: {
        origin_name: false,
        origin_lastname: false,
        origin_document: false,
        origin_phone: false,
        origin_email: false
      },
      dialog: {
        confirmPayment: false,
        successfulPayment: false,
        invalidData: false,
        waitingPayment: false,
        invalidNumber: { state: false, persistent: false },
        invalidAmount: { state: false, persistent: false },
        invalidSignature: false,
        checkInternetConnection: false
      },
      iframe: false,
      errorCC: undefined,
      errorPSE: undefined,
      validReceiver: false,
      user: {},
      commerce: {},
      paymentData: {},
      hasParams: false,
      transaction_id: 10,
      redirect_url: undefined,
      trans_date: undefined,
      trans_id: undefined,
      trans_signature: undefined,
      trans_signature_pse: undefined,
      site_id: undefined,
      ctx_mode: undefined,
      webcheckout: false,
      //styles configurations
      configurations: undefined,
      sublink: undefined,
      defaultStyle: '{"data":{"url":"http://puntpay.co/","supplier_code":"f0bd118b78388b4e4a02b40260c33a04d12a9ce314a3c4538de3cca294b25aa8","transaction_minimum_amount":10000,"transaction_maximum_amount":1500000,"logo_url":"","banner_url":"https://suppliers-smartlink.s3.amazonaws.com/banner.jpg","header_color":"#9A3870","footer_color":"#9A3870","callback_url":"https://puntopay.co/","checkbox":false,"detail_checkbox":{}}}'
    };
  },
  computed: {
    iconUrl() {
      return require("../assets/check.png");
    }
  },
  async mounted() {
    // console.log("Ambiente actual:", "URL base", process.env.VUE_APP_PUNTOPAY_URL, process.env);
    // Configurar look and feel de la página
    // Configurar dado el supplier_code
    let body = {}
    if( this.$route.query.code ) {
      body = { "code": this.$route.query.code }
    } 
    // Configurar dada la URL de la página
    else {
      body = { "url": window.location.href.split('?')[0] }
    }
    
    this.configurations = await this.getSmartlinkConfiguration(body);
    if (this.configurations.data.webcheckout) {
      this.setPhoneParams(this.configurations.data.phone);
    }
    // TODO: Usar los datos para configurar la pagina
    //console.log(look);
    // Validar información si viene de los params
    if (
      this.$route.query.transaction_id ||
      this.$route.query.amount ||
      this.$route.query.phone ||
      this.$route.query.redirect_url ||
      this.$route.query.signature
    ) {
      if(this.$route.query.signature){
        const validSignature = await this.validateSignature(this.$route.query);
        if (!validSignature) this.dialog.invalidSignature = true;
        const validTransaction =
          validSignature &&
          (await this.validateReceiver(this.$route.query.phone));
        if (validSignature && !validTransaction) {
          this.dialog.invalidNumber.state = true;
          this.dialog.invalidNumber.persistent = true;
        }

        if (validTransaction) {
          this.setParams(this.$route.query);
          this.$refs.receiver.requestFocus();
        }
      }else{
        let validTransaction = undefined;
        if( this.commerce.phone == undefined ){
          validTransaction = (await this.validateReceiver(this.$route.query.phone));
        }else{
          validTransaction = true;
        }
          
        if (!validTransaction) {
          this.dialog.invalidNumber.state = true;
          this.dialog.invalidNumber.persistent = true;
        }
        if (validTransaction) {
          this.setParams(this.$route.query);
          this.$refs.receiver.requestFocus();
        }
      }
      
    }
    this.$vuetify.theme.themes.light.primary = this.configurations.data.header_color


    // this.kushki = new Kushki({
    //   merchantId: process.env.VUE_APP_KUSHKI_MERCHANT_ID,
    //   inTestEnvironment: !(process.env.VUE_APP_KUSHKI_IN_TEST_ENV == "false"),
    //   regional: false
    // });
    // this.requestBankList();
  },
  methods: {
    async getSmartlinkConfiguration(body) {
      try {
        let res = await this.$http.post(
          "/supplier/smartlink-configuration", body
        );
        return res.data;
      } catch (error) {
        this.dialog.invalidSignature = true
        return JSON.parse(this.defaultStyle);
      }
    },
    async processPayment() {
      this.dialog.waitingPayment = true;
      try {
        let res = await this.$http.post(
          `http://6ebcdba112ac.ngrok.io/transactions/smartlink/v2`, {
            transaction: {
              payment_type: 2,
              origin_name: this.user.name,
              origin_lastname: this.user.lastname,
              origin_document: this.user.document || "",
              origin_phone: this.user.phone.replace(/\s/g, ""),
              origin_email: this.user.email || "",
              destination_phone: this.commerce.phone.replace(/\s/g, ""),
              amount: this.commerce.amount,
              description: "Test",
              supplier_code: this.configurations.data.supplier_configurations,
              sublink: this.sublink
            }
          }
        );

        this.dialog.waitingPayment = false;

        const data = new FormData();

        data.append("vads_action_mode", "INTERACTIVE");
        data.append("vads_amount", this.commerce.amount);
        data.append("vads_ctx_mode", "TEST");
        data.append("vads_currency", 170);
        data.append("vads_cust_cell_phone", this.user.phone.replace(/\s/g, ""));
        data.append("vads_cust_email", this.user.email);
        data.append("vads_cust_first_name", this.user.name);
        data.append("vads_cust_last_name", this.user.lastname);
        data.append("vads_cust_phone", this.user.document);
        data.append("vads_page_action", "PAYMENT");
        data.append("vads_language", "es");
        data.append("vads_payment_config", "SINGLE");
        data.append("vads_site_id", 23824163);
        data.append("vads_trans_date", res.data.data.date);
        data.append("vads_trans_id", res.data.data.code);
        data.append("vads_version", "V2");
        data.append("signature", res.data.data.signature);

        res = await this.$http.post(process.env.VUE_APP_PAYZEN_URL, data).
        catch(e => { 
          if(e.response.status == 302) 
            console.log(e.response);
        });
        console.log(JSON.stringify(res.headers));
        console.log(JSON.stringify(res.config));

        var w = window.open(res.config.url);
        w.document.write(res.data);
        w.document.URL = res.config.url;
      } catch (error) {
        this.dialog.waitingPayment = false;
      }
    },
    handleConnectivityChange(status) {
      this.dialog.checkInternetConnection = !status;
    },
    groupChange(text) {
      this.sublink = text;
      this.description = text;
    },
    setPhoneParams(phone) {
      this.commerce.phone = phone;
      this.webcheckout = true;
    },
    setParams({ transaction_id, amount, phone, redirect_url, origin_name, origin_lastname,
                origin_document, origin_phone, origin_email
    }) {
      this.visible_params = false;
      this.commerce.amount = amount;
      if( this.commerce.phone == undefined )
        this.commerce.phone = phone;
      this.$refs.receiver.setAmount(amount);
      this.hasParams = true;
      this.validReceiver = true;
      this.enabledReceiver = false;
      this.transaction_id = transaction_id;
      this.redirect_url = redirect_url;
      if(amount == undefined || amount == 0){
         this.visible_params = true;
         this.enabledReceiver = true;
         this.validReceiver = false;
         this.hasParams = false;
      }
      //Boton de pago
      if(origin_name != undefined){
        this.user.name = origin_name;
        this.web_checkout.origin_name = true;
      }
        if(origin_lastname != undefined){
        this.user.lastname = origin_lastname;
        this.web_checkout.origin_lastname = true;
      }
      if(origin_document != undefined){
        this.user.document = origin_document;
        this.web_checkout.origin_document = true;
      }
      if(origin_phone != undefined){
        this.user.phone = origin_phone;
        this.web_checkout.origin_phone = true;
      }
      if(origin_email != undefined){
        this.user.email = origin_email;
        this.web_checkout.origin_email = true;
      } 
    },
    async validateSignature({
      transaction_id,
      amount,
      phone,
      signature
      // redirect_url
    }) {
      if (!transaction_id || !amount || !phone || !signature)
        return Promise.resolve(false);

      try {
        await this.$http.post("/transactions/verify-signature", {
          transaction: {
            mobile: phone,
            id: transaction_id,
            amount,
            signature
            // redirect_url
          }
        });
        return Promise.resolve(true);
      } catch (error) {
        if (error.response.status === 403) return Promise.resolve(false);
        else {
          this.dialog.checkInternetConnection = true;
          return Promise.resolve(false);
        }
      }
    },
    loadBankList(banks) {
      this.bankList = banks;
    },
    requestBankList() {
      this.kushki.requestPseBankList(this.loadBankList);
    },
    returnShop() {
       window.location.href = this.configurations.data.callback_url;
    },
    backStepper() {
      if (this.stepper > 1) this.stepper--;
    },
    clearBankData() {
      this.paymentData = {};
      if (this.$refs.creditCard) this.$refs.creditCard.clearFields();
    },
    async validateUserInformation() {
      // TODO uncomment

      const errors = await this.$refs.issuerReceiver.validate();
      if (!errors){ 
        this.dialog.invalidData = true;
        return;
      }
      if (this.validReceiver === true){
        this.dialog.waitingPayment = true;

        if (this.transaction_id === undefined){
          this.transaction_id = this.user.transaction_id;
        }
        let res = await this.$http.post("/transactions/smartlink/v2", {
            transaction: {
              payment_type: 2,
              origin_name: this.user.name,
              origin_lastname: this.user.lastname,
              origin_document: this.user.document || "",
              origin_phone: this.user.phone.replace(/\s/g, ""),
              origin_email: this.user.email || "",
              destination_phone: this.commerce.phone.replace(/\s/g, ""),
              amount: this.commerce.amount,
              description: this.transaction_id,
              supplier_code: this.configurations.data.supplier_code,
              sublink: this.sublink
            }
          }
        );
        this.trans_id = res.data.data.code;
        this.trans_date = res.data.data.date;
        this.trans_signature = res.data.data.signature;
        this.trans_signature_pse = res.data.data.signature_pse;
        this.user.finalphone = this.user.phone.replace(/\s/g, '');
        this.site_id = res.data.data.site_id
        this.ctx_mode = res.data.data.ctx_mode;
        this.dialog.waitingPayment = false;

        
        
        this.stepper++;
      } 
    },
    async openConfirm() {
      const errors = await this.$refs.payment.validate();
      if (!errors) return;
      this.errorCC = this.errorPSE = undefined;
      this.dialog.confirmPayment = true;
    },
    processPSEResponse(res) {
      if (!res.code) this.sendToken(res.token, 2);
      else {
        this.dialog.waitingPayment = false;
        this.errorCC =
          "Ocurrió un problema con tu método de pago - Verifica tus datos";
      }
    },
    async onConfirm() {
      this.dialog.confirmPayment = false;
      this.dialog.waitingPayment = true;

      if (this.tab === 0) {
        // Credit card selected
        const month = this.paymentData.monthYear.month;
        const year = this.paymentData.monthYear.year;

        this.kushki.requestToken(
          {
            card: {
              cvc: this.paymentData.cvc,
              expiryMonth: month,
              expiryYear: year,
              name: this.paymentData.name,
              number: this.paymentData.number
            },
            currency: "COP",
            amount: this.commerce.amount
          },
          this.processCCResponse
        );
      } else {
        // PSE Selected
        try {
          this.kushki.requestTransferToken(
            {
              bankId: this.paymentData.bank,
              amount: {
                subtotalIva: 0,
                subtotalIva0: Number(this.commerce.amount),
                iva: 0,
                extraTaxes: {
                  propina: 0,
                  tasaAeroportuaria: 0,
                  agenciaDeViajes: 0,
                  iac: 0
                }
              },
              userType: String(this.paymentData.userType),
              documentType: this.user.documentType,
              documentNumber: this.user.document,
              currency: "COP",
              email: this.user.email,
              paymentDescription: this.paymentData.paymentDescription,
              callbackUrl: this.redirect_url || CALLBACK_URL
            },
            this.processPSEResponse
          );
        } catch (error) {
          this.errorPSE = true;
        } finally {
          this.dialog.waitingPayment = false;
        }
      }
    },
    onAccept() {
      this.paymentData = {};
      this.user = {};
      this.commerce = {};
      this.dialog.successfulPayment = false;
      this.$router.go();
    },
    onAcceptData() {
      this.dialog.invalidData = false;
    },
    processCCResponse(res) {
      if (res.error) {
        this.dialog.waitingPayment = false;
        this.errorCC =
          "Ocurrió un problema con tu método de pago - Verifica tus datos";
      } else this.sendToken(res.token, 1);
    },
    editReceiver() {
      this.enabledReceiver = true;
      this.validReceiver = false;
    },
    async doReceiverValidation(phone,amount) {
      
      phone;
      this.validReceiver = false;
      //this.enabledReceiver = false;

      const errors = await this.$refs.issuerReceiver.validate();
      if (!errors) {
        this.dialog.invalidNumber.state = true;
        return Promise.resolve(false);
      } 

      if (amount < this.configurations.data.transaction_minimum_amount || amount > this.configurations.data.transaction_maximum_amount){
        this.dialog.invalidAmount.state = true;
        return Promise.resolve(false);
      }     

      const validReceiver = await this.validateReceiver(phone);
      if (!validReceiver) this.dialog.invalidNumber.state = true;
    },
    async validateReceiver(phone) {
      if (!phone) return Promise.resolve(false);

      try {
        await this.$http.get(
          `/smart-link-valid?supplier_code=${this.configurations.data.supplier_code}&mobile=${phone
            .split("")
            .filter(val => val <= "9" && val >= "0")
            .join("")}&token=${process.env.VUE_APP_SUPPLIER_CODE}`
        );
        this.validReceiver = true;
        this.enabledReceiver = false;
        return Promise.resolve(true);
      } catch (error) {
        this.validReceiver = false;
        return Promise.resolve(false);
      }
    },
    async sendToken(token, type) {
      try {
        const response = await this.$http.post("/transactions/smartlink", {
          transaction: {
            payment_type: type,
            origin_name: this.user.name,
            origin_lastname: this.user.lastname,
            origin_document: this.user.document || "",
            origin_phone: this.user.phone.replace(/\s/g, ""),
            origin_email: this.user.email || "",
            destination_phone: this.commerce.phone.replace(/\s/g, ""),
            token,
            amount: this.commerce.amount,
            description:
              this.transaction_id ||
              `Pago por ${type === 2 ? "PSE" : "Tarjeta de crédito"}`,
            supplier_code: this.configurations.data.supplier_code
          }
        });

        if (type == 2) {
          location.assign(response.data.data.extra_data.redirect_url);
        }

        this.errorPSE = false;
        this.errorCC = undefined;
        if (type == 1) {
          this.dialog.successfulPayment = true;
          this.paymentData = {};
          if (this.redirect_url) location.assign(this.redirect_url);
        }
      } catch (error) {
        this.errorCC = error.response.data.data.errors[0];
      } finally {
        this.dialog.waitingPayment = false;
      }
    }
  },
  watch: {
    stepper() {
      this.clearBankData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.web_checkout
  margin: auto !important
  text-size: 2em
  max-width: 60%

@import 'scss/variables.scss'
.payment-buttons
  height: 100px
  width: 200px

.border-top-rounded
  border-top-left-radius: 5px
  border-top-right-radius: 5px

@media (min-width: 108px) 
  .iframe
    height: 120vh 

@media (min-height: 350px) 
  .iframe
    height: 100vh 

/* Using SCSS variables to store breakpoints */
$breakpoint-tablet: 768px
@media (min-width: $breakpoint-tablet) 
  .iframe
    height: 65vh
    width: 60%




</style>
